import React from "react";
import PropTypes from "prop-types";
import { BASE_IMAGE_API_URL } from "../../services/baseServices";

export default function ViewContentByType({ viewObj }) {

    return (
        <div
            className="offcanvas offcanvas-end"
            tabIndex="-1"
            id="offcanvasRightView"
            aria-labelledby="offcanvasRightLabel"
            style={{ minWidth: "45%", maxWidth: "45%" }}
        >
            <div className="offcanvas-header d-flex justify-content-between align-items-center">
                <h5 id="offcanvasRightLabel" className="mb-0">View Content by Type</h5>
                <div className="d-flex align-items-center">
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <div className="offcanvas-body" style={{ marginTop: "-2rem", maxHeight: "42rem", overflowY: "auto" }}>
                <div className="row">
                    <div className="col-6 mb-2">
                        <label className="form-label">Title</label>
                        <input 
                            className="form-control"
                            value={viewObj?.Title}
                            readOnly
                        />
                    </div>
                    <div className="col-6 mb-2">
                        <label className="form-label">Icon</label>
                        <div
                            className="icon"
                            dangerouslySetInnerHTML={{ __html: viewObj?.IconName }}
                        ></div>
                    </div>
                    <div className="col-12 mb-2">
                        <label className="form-label">Description-1</label>
                        <div
                            className="form-control"
                            style={{ minHeight: '100px' }}
                            dangerouslySetInnerHTML={{ __html: viewObj?.Description1 }}
                        />
                    </div>

                    <div className="col-12 mb-2">
                        <label className="form-label">Description-2</label>
                        <div
                            className="form-control"
                            style={{ minHeight: '100px' }}
                            dangerouslySetInnerHTML={{ __html: viewObj?.Description2 }}
                        />
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label">Image 1</label>
                        <img
                            src={`${BASE_IMAGE_API_URL}${viewObj?.ImageUrl1}`}
                            alt="Image 1"
                            style={{
                                width: '100%',
                                maxHeight: '300px',
                                objectFit: 'contain',
                                borderRadius: '6px',
                                padding: '4px',
                            }}
                        />
                    </div>

                    <div className="col-12 mb-3">
                        <label className="form-label">Image 2</label>
                        <img
                            src={`${BASE_IMAGE_API_URL}${viewObj?.ImageUrl2}`}
                            alt="Image 2"
                            style={{
                                width: '100%',
                                maxHeight: '300px',
                                objectFit: 'contain',
                                borderRadius: '6px',
                                padding: '4px',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

ViewContentByType.propTypes = {
    viewObj: PropTypes.object.isRequired,
};
